// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"50acc379","75":"60abfb96","116":"e1e97ed8","453":"b7b3ca75"}[chunkId] + ".chunk.js";
};